import { getIsAGE, parseAGEUrl } from './parse-portal-url'
import { DEFAULT_AGOL_PORTAL_URL } from '../constant'

export default function getClientPortalUrl (newPortalUrl) {
  let portalUrl
  if (newPortalUrl) {
    // Use portalUrl from user's input
    portalUrl = newPortalUrl
  }
  if (!portalUrl) {
    // Use portalUrl from address bar
    const searchParams = new URLSearchParams(window.location.search)
    portalUrl = searchParams.get('portalUrl')
  }
  if (!portalUrl) {
    // Use portalUrl from storage
    portalUrl = window.localStorage.getItem('instalinkPortalUrl')
  }
  if (portalUrl && getIsAGE(portalUrl)) {
    portalUrl = parseAGEUrl(portalUrl)
    return portalUrl
  }
  if (!portalUrl) {
    // Fallback to Arcgis online URL as last resort
    portalUrl = DEFAULT_AGOL_PORTAL_URL
  }
  return portalUrl
}
